import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../shared";
import { LoginSubjectToEmployeeLinkContainerModel } from "../../../../../models/aggregates/employee";

// https://api.akaun.cloud/core2/tnt/dm/login-subject-to-employee-links/tenant-ep/

@Injectable({ providedIn: "root" })
export class LoginSubjectToEmployeeTenatEpService extends BaseApiTemplateService<LoginSubjectToEmployeeLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "login-subject-to-employee-links/tenant-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "login-subject-to-employee-links/tenant-ep";
    this.httpClient = http;
  }
}
